import { RootState } from '@/models/root-state.model';
import { createSelector } from 'reselect';
import { WalletModel } from '@/store/wallet/reducers';
import { BffApiErrorCode } from '@/models/bff-api-error';

export const selectWallet = (state: RootState): WalletModel => state.wallet.wallet;
export const selectWalletError = (state: RootState): BffApiErrorCode | undefined =>
  state.wallet.error;
export const selectWalletLoading = (state: RootState): boolean => state.wallet.loading;

export const selectUserBalance = createSelector(selectWallet, (wallet): number | null => {
  return wallet.balance;
});

export const selectUserWithdrawableBalance = createSelector(
  selectWallet,
  (wallet): number | null => {
    return wallet.withdrawableBalance;
  },
);

export const selectUserDepositCount = createSelector(selectWallet, (wallet): number | null => {
  return wallet.depositCount;
});

export const selectIsFtd = createSelector(selectUserDepositCount, depositCount =>
  Boolean(depositCount && depositCount === 0),
);

export const selectLastSuccessfulDeposit = createSelector(
  selectWallet,
  wallet => wallet.lastSuccessfulDeposit,
);

export const selectLifetimeDeposit = createSelector(selectWallet, wallet => wallet.lifetimeDeposit);
